module.exports = __webpack_public_path__ + "img/film-estirable.81f0758a.jpg";